/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Checkbox, Col, Form } from 'antd';

import { createShowField } from '../../../../Components/ResourceFieldLayout/shouldRenderTaskField';

function FormCertificateFieldsComponent({
  fieldsPermissions,
  isTaskReadOnly,
  isEditing,
  task,
  fieldLayout,
  roleId,
  fieldNameFilter,
  hideSectionCard,
}) {
  const showField = createShowField(fieldsPermissions, fieldLayout, roleId, fieldNameFilter);
  const inner = (
    <>
      {/* Não Gera Certificado */}
      {showField('NotHaveCertificate') && (
        <Col span={24}>
          <Form.Item
            label="Não Possui Certificado"
            name="notHaveCertificate"
            valuePropName="checked"
          >
            <Checkbox
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.NotHaveCertificate.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}
    </>
  );

  if (hideSectionCard) {
    return inner;
  }

  return (
    <Col span={24}>
      <Card title="Certificado" bordered={false} className="task-form-section-card">
        {inner}
      </Card>
    </Col>
  );
}

export default FormCertificateFieldsComponent;
